<div class=" receipt-container">
  <div [innerHTML]="getSafe(html)"></div>
</div>